const HomeStub = () => {
  return <div data-testid="home-stub" />;
};

export default HomeStub;
